import { Link } from 'react-router-dom'
import type { NavItem } from '@/constants/navigation'
import { splitGroupChildren } from './nav-model'
import type { RailFloatApi } from './useNavShell'

/** Collapsed-rail tooltip (items) or flyout submenu (groups). */
export function RailFloat({ rail, activeId }: { rail: RailFloatApi; activeId: string }) {
  const { target, visible, keep, close, hide } = rail
  if (!target) return null
  const { entry } = target
  if (entry.type === 'item') {
    return (
      <div className="ns-float ns-tip" data-show={visible} style={{ top: target.top }} role="tooltip">
        {entry.label}
      </div>
    )
  }
  const parts = splitGroupChildren(entry)
  const renderLink = (child: NavItem) => (
    <Link key={child.id} to={child.href} data-active={child.id === activeId} onClick={hide}>
      <child.icon strokeWidth={1.75} />
      {child.label}
    </Link>
  )
  return (
    <div
      className="ns-float ns-fly"
      data-show={visible}
      style={{ top: target.top, maxHeight: `calc(100dvh - ${Math.max(0, target.top)}px - 12px)` }}
      inert={visible ? undefined : true}
      onMouseEnter={keep}
      onMouseLeave={close}
    >
      <h6>{entry.label}</h6>
      {parts.flat.map(renderLink)}
      {parts.subs.map(({ sub, items }) => (
        <div key={sub.id} className="ns-fly-sub" role="group" aria-label={sub.label}>
          <h6>
            <sub.icon strokeWidth={1.75} />
            {sub.label}
          </h6>
          {items.map(renderLink)}
        </div>
      ))}
    </div>
  )
}
